import React from 'react';
import { Routes, Route } from 'react-router-dom';

import AdminLayout from './admin/AdminLayout';
import AuditLog from './admin/AuditLog';
import Communications from './admin/Communications';
import Dashboard from './admin/Dashboard';
import EmailTemplates from './admin/EmailTemplates';
import Magazine from './admin/Magazine';
import MemberDetails from './admin/MemberDetails';
import MembershipRequests from './admin/MembershipRequests';
import MembersList from './admin/MembersList';
import Payments from './admin/Payments';
import Reports from './admin/Reports';
import Settings from './admin/Settings';

function Admin() {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="members" element={<MembersList />} />
        <Route path="members/:id" element={<MemberDetails />} />
        <Route path="requests" element={<MembershipRequests />} />
        <Route path="requests/:id" element={<MemberDetails />} />
        <Route path="payments" element={<Payments />} />
        <Route path="reports" element={<Reports />} />
        <Route path="magazine" element={<Magazine />} />
        <Route path="email-templates" element={<EmailTemplates />} />
        <Route path="communications" element={<Communications />} />
        <Route path="audit-log" element={<AuditLog />} />
        <Route path="documents" element={<div className="text-white">Documents Coming Soon</div>} />
        <Route path="settings" element={<Settings />} />
      </Routes>
    </AdminLayout>
  );
}

export default Admin;
